import jwtDecode from 'jwt-decode';

/** access_token JWT의 exp를 밀리초 단위 timestamp로 반환 (디코드 실패 시 0) */
export const getTokenExpiry = (accessToken: string): number => {
  try {
    const decoded: User.Token.DecryptedAccessToken = jwtDecode(accessToken);
    return decoded.exp * 1000;
  } catch {
    return 0;
  }
};